export default {
    header: {
        telefone: "Telefono",
        signIn: "Accedi",
        register: "Registrati",
        becomeExpert: "Registra la tua azienda",
        dashboard: "Pannello di controllo",

        sidebar: {
            tuktuk: {
                title: "Tuk Tuk",
                subtitle: "Prenotazione Tuk Tuk",
                menu: {
                    grid: "Elenco Tuk Tuk",
                },
            },
            about: {
                title: "Informazioni",
                subtitle: "Informazioni",
                menu: {
                    aboutUs: "Chi siamo",
                    testimonials: "Testimonianze",
                    faq: "Domande frequenti",
                    contact: "Contattaci",
                    terms: "Termini e condizioni",
                    privacy: "Politica sulla privacy",
                },
            },
            dashboard: {
                title: "Pannello di controllo",
                subtitle: "Pannello utente",
                subtitle2: "Pannello agente",
                menu: {
                    dashboard: "Pannello di controllo",
                    myBookings: "Le mie prenotazioni",
                    reviews: "Recensioni",
                    support: "Supporto",
                    wishlist: "Lista dei desideri",
                    wallet: "Portafoglio",
                    profileSettings: "Impostazioni del profilo",
                    notifications: "Notifiche",
                    myProfile: "Il mio profilo",
                    settings: "Impostazioni",
                    dashboard2: "Pannello di controllo",
                    bookings: "Prenotazioni",
                    enquiries: "Richieste",
                    earnings: "Guadagni",
                    reviews2: "Recensioni",
                    settings2: "Impostazioni",
                },
            },
            social: {
                title: "Social Network",
                subtitle: "Feed di post",
                menu: {
                    feed: "Feed",
                    myProfilePage: "La mia pagina profilo",
                    explore: "Esplora",
                },
            },
        },
    },

    common: {
        welcome: "Benvenuto, {{name}}!",
    },

    home: {
        hero: {
            title: "Avvicinati al sogno:",
            title2: "l'essenziale per il tuo viaggio ti aspetta",
            title3: "tu",
            subtitle: "La tua destinazione definitiva per tutto ciò che aiuta a celebrare e ricordare la tua esperienza di viaggio.",
            tukTuk: "Tuk Tuk",
        },
        searchBy: {
            titlePrefix: "Pacchetti",
            titleSuffix: "recenti",
            subtitle:
                "Scopri i pacchetti più recenti aggiunti a Portugalwaytour ed esplora opportunità di viaggio uniche selezionate con cura per offrirti esperienze indimenticabili, nuove destinazioni e avventure esclusive in tutto il mondo.",
            noPackages: "Nessun pacchetto recente trovato.",
            hasDiferencial: "Ha un vantaggio",
            noReviews: "Nessuna recensione",
            viewAll: "Vedi tutti i pacchetti",
        },
        sectionBenefit: {
            titlePrefix: "I nostri",
            titleHighlight: "Benefici",
            titleSuffix: "e principali vantaggi",
            subtitle:
                "Portugalway, un tour operator specializzato in destinazioni da sogno, offre una varietà di vantaggi per i viaggiatori.",
            benefits: [
                {
                    title: "Esperienze Autentiche",
                    description:
                        "Fuggi dal turismo tradizionale e scopri il Portogallo autentico! I nostri tour offrono esperienze genuine esplorando la cultura locale, la cucina e luoghi segreti.",
                },
                {
                    title: "Pacchetti Viaggio Personalizzati",
                    description:
                        "Crea il tuo viaggio su misura! Scegli la tua esperienza e noi ci occupiamo di tutto: alloggio, trasporto e attività, per un viaggio personalizzato e indimenticabile.",
                },
                {
                    title: "Comfort e Sicurezza",
                    description:
                        "Ci occupiamo di ogni dettaglio: trasporto confortevole, alloggio selezionato e accompagnamento di guide professionali, garantendo tranquillità dall'inizio alla fine del viaggio.",
                },
                {
                    title: "Assistenza Dedicata",
                    description:
                        "Dal primo contatto al ritorno dal tuo viaggio, hai a disposizione un supporto personalizzato e un team pronto a rispondere in portoghese e inglese, con agilità e totale attenzione alle tue esigenze.",
                },
            ],
        },
        exploreCities: {
            title: "Esplora per città",
            subtitle: "Scopri esperienze uniche in destinazioni incredibili",
        },
        placeSection: {
            titlePrefix: "Pacchetti",
            titleHighlight: "di tendenza",
            subtitle:
                "Esplora i nostri pacchetti di viaggio più popolari, accuratamente selezionati per le loro alte valutazioni, recensioni positive e prenotazioni frequenti da parte di altri viaggiatori. Trova qui la tua prossima avventura indimenticabile.",
            all: "Tutti",
            hasDiferencial: "Ha un vantaggio",
            noReviews: "Nessuna recensione",
            viewAll: "Vedi tutti i pacchetti",
        },
        aboutSection: {
            welcome: "Benvenuto a Portugalwaytour",
            title: "Esplora oltre l'orizzonte: scopri le meraviglie del mondo",
            description1: "In Portugal Way Tour, crediamo che viaggiare sia trasformare. Siamo un'agenzia specializzata in esperienze turistiche uniche in Portogallo, impegnata a rivelare il meglio del paese — la sua cultura, paesaggi, storia e autenticità.",
            point1: "Offrire viaggi memorabili, con comfort, sicurezza e incanto. Vogliamo che ogni turista scopra il Portogallo in profondità, con itinerari che mescolano tradizione, natura, gastronomia e genuina ospitalità.",
            point2: "Essere un riferimento di qualità e fiducia nel turismo in Portogallo, riconosciuta dai turisti di tutto il mondo come sinonimo di professionalità e incanto.",
            learnMore: "Scopri di più",
            reviews: "{{count}}+ Recensioni"
        },
        aboutCounters: [
            { label: "Destinazioni in tutto il mondo", icon: "isax-global5", colorClass: "text-teal" },
            { label: "Prenotazioni completate", icon: "isax-calendar-2", colorClass: "text-purple" },
            { label: "Clienti a livello globale", icon: "isax-tag-user5", colorClass: "text-pink" },
            { label: "Fornitori registrati", icon: "isax-status-up5", colorClass: "text-info" },
        ],
        expertSection: {
            popularTitle: "Popolari",
            popularSubtitle: "Scopri i servizi più popolari, ben recensiti e frequentemente prenotati dai viaggiatori.",
            serviceName: "Conducente di Tuk Tuk",
            loading: "Caricamento...",
            reservationsSingular: "prenotazione",
            reservationsPlural: "prenotazioni",
            viewProfile: "Vedi profilo",
            viewAll: "Vedi tutti",
        },
        driverModal: {
            loading: "Caricamento...",
            description: "Descrizione",
            languages: "Lingue",
            vehicle: "Veicolo",
            seats: "posti",
            averageRating: "Valutazione media",
            reviews: "Recensioni",
            packages: "Pacchetti",
            noReviews: "Ancora nessuna recensione",
            noPackages: "Questo autista non ha pacchetti registrati"
        },
        testimonialSection: {
            title: "Cosa dicono i nostri {{highlight}}",
            highlight: "utenti",
            subtitle: "Scopri cosa hanno pensato i nostri viaggiatori delle loro esperienze.",
            loading: "Caricamento recensioni...",
            noReviews: "Nessuna recensione trovata.",
            noComment: "L'utente non ha lasciato commenti.",
            viewPackage: "Vedi dettagli del pacchetto"
        },
        updateSection: {
            faq: {
                title: "Domande {{highlight}}",
                highlight: "Frequenti",
                subtitle: "Portugalway, un tour operator specializzato in destinazioni da sogno, offre una varietà di vantaggi per i viaggiatori.",
                questions: [
                    {
                        question: "Come faccio a prenotare un tour?",
                        answer: "Puoi prenotare direttamente tramite il nostro sito web o contattarci via e-mail o telefono. Dopo aver definito l'itinerario desiderato, ti forniremo un preventivo, confermeremo hotel e servizi, e richiederemo il pagamento secondo la politica informata."
                    },
                    {
                        question: "È possibile personalizzare l'itinerario?",
                        answer: "Sì! Tutti i nostri itinerari sono flessibili. Tu scegli i luoghi che vuoi visitare, la durata, il tipo di alloggio e, nei limiti del possibile, creiamo qualcosa che si adatti al tuo profilo."
                    },
                    {
                        question: "Quali sono le lingue delle guide?",
                        answer: "Abbiamo guide che parlano portoghese, inglese e, a seconda del tour, altre lingue. Informaci delle tue preferenze al momento della prenotazione in modo da poter assegnare la guida più adatta."
                    },
                    {
                        question: "Qual è la politica di cancellazione?",
                        answer: "Abbiamo una politica di cancellazione che varia in base al tour, all'anticipo e ai fornitori. Al momento della prenotazione, ti invieremo i termini completi. Ti preghiamo di leggere attentamente prima di confermare."
                    },
                    {
                        question: "Quali sono le forme di pagamento accettate?",
                        answer: "Accettiamo bonifico bancario internazionale, carta di credito e, in alcuni casi, altri metodi di pagamento."
                    }
                ],
                contactUsText: "Se non trovi la risposta alla tua domanda nelle nostre FAQ, contattaci. Ti risponderemo a breve!",
                contactButton: "Contattaci",
            },
            support: {
                items: [
                    "Itinerari Personalizzati",
                    "Pianificazione Completa",
                    "Orientamento di Esperti",
                    "Esperienza Locale",
                    "Supporto Clienti",
                    "Sforzi di Sostenibilità",
                    "Molteplici Regioni"
                ]
            }
        }
    },
    footer: {
        pages: {
            title: "Pagine",
            settings: "Impostazioni",
            profile: "Profilo",
            social: "Social Network",
        },
        company: {
            title: "Azienda",
            about: "Chi siamo",
            testimonials: "Testimonianze",
            faq: "Domande frequenti",
        },
        support: {
            title: "Supporto",
            contact: "Contattaci",
            privacy: "Politica sulla privacy",
            terms: "Termini e condizioni",
            chat: "Assistenza via chat",
        },
        services: {
            title: "Servizi",
            tuktuk: "Tuk Tuk",
            winery: "Cantina",
            restaurant: "Ristorante",
            car: "Auto",
            hippotrip: "Hippotrip",
            bike: "Bicicletta",
        },
        bottom: {
            copyright: "Copyright © 2025. Tutti i diritti riservati,",
            brand: "Portugalwaytour",
            social: [
                { icon: "fa-brands fa-facebook", link: "#" },
                { icon: "fa-brands fa-x-twitter", link: "#" },
                { icon: "fa-brands fa-instagram", link: "#" },
                { icon: "fa-brands fa-linkedin", link: "#" },
                { icon: "fa-brands fa-pinterest", link: "#" },
            ],
            cards: [
                "assets/img/icons/card-01.svg",
                "assets/img/icons/card-02.svg",
                "assets/img/icons/card-03.svg",
                "assets/img/icons/card-04.svg",
                "assets/img/icons/card-05.svg",
                "assets/img/icons/card-06.svg",
            ],
        },
    },

    auth: {
        registerModal: {
            title: "Accedi al tuo account",
            subtitle: "Inserisci la tua e-mail per accedere o creare un account",
            emailLabel: "E-mail",
            emailPlaceholder: "Inserisci la tua e-mail",
            sendTestCode: "Invia codice di prova",
            sendEmailCode: "Invia codice via e-mail",
            codeLabel: "Codice di verifica",
            codePlaceholder: "Inserisci il codice",
            verifyAndLogin: "Verifica e Accedi",
            testCodeSuccess: "Codice di prova '123456' generato. Usalo per l'accesso.",
            testCodeError: "Errore durante la generazione del codice di prova.",
            emailSent: "Codice inviato alla tua e-mail!",
            emailError: "Errore durante l'invio del codice via e-mail.",
            loginSuccess: "Accesso effettuato con successo!",
            invalidCode: "Codice non valido o scaduto.",
            or: "Oppure",
            google: "Google",
            facebook: "Facebook",
            reminderTitle: "Completa il tuo profilo",
            reminderText: "Non dimenticare di completare il tuo profilo per sfruttare tutte le funzionalità della piattaforma!",
            gotIt: "Capito",
        },
    },
    companyRegisterModal: {
        title: "Registrazione Azienda",
        step1: "Inserisci la tua e-mail personale per creare un account amministratore dell'azienda. Utilizzerai questo account per gestire il profilo aziendale.",
        step2: "Abbiamo inviato un codice di verifica alla tua e-mail. Inseriscilo qui sotto per verificare la tua identità.",
        step3: "Ora compila i dati della tua azienda. L'e-mail aziendale deve essere un contatto aziendale (es.: info@azienda.com).",

        personalEmail: "La tua e-mail personale",
        sendTestCode: "Invia codice di prova",
        sendEmailCode: "Invia codice via e-mail",

        verificationCode: "Codice di verifica",
        verifyCode: "Verifica codice",

        companyEmail: "E-mail dell'azienda",
        companyName: "Nome dell'azienda",
        nif: "NIF",
        nib: "NIB",
        permanentCertificate: "Numero del certificato permanente",
        phone: "Telefono",
        street: "Via",
        city: "Città",
        postalCode: "Codice postale",
        country: "Paese",
        companyDescription: "Breve descrizione dell'azienda",
        servicesProvided: "Servizi offerti",

        contractTitle: "Contratto Aziendale",
        acceptContract: "Accetto il contratto aziendale",
        finishRegistration: "Completa la registrazione",

        messages: {
            "Test code sent successfully. Use '123456'.": "Codice di prova inviato con successo. Usa '123456'.",
            "Verification email sent successfully.": "E-mail di verifica inviata con successo.",
            "Verification successful.": "Verifica completata con successo.",
            "Company registered and contract accepted successfully!": "Azienda registrata e contratto accettato con successo!",
            testStepMessage: "Codice di prova inviato con successo. Usa '123456'.",
            emailStepMessage: "Un codice di verifica è stato inviato alla tua e-mail. Inseriscilo qui sotto."
        },

        errors: {
            "Failed to send the verification code.": "Impossibile inviare il codice di verifica.",
            "Invalid or expired code.": "Codice non valido o scaduto.",
            "Please fill all required fields.": "Per favore, compila tutti i campi richiesti.",
            "You must accept the contract to register the company.": "Devi accettare il contratto per registrare l'azienda.",
            "You must be logged in to register the company.": "Devi essere loggato per registrare l'azienda.",
            "Failed to register the company or accept the contract.": "Impossibile registrare l'azienda o accettare il contratto."
        }
    },
    chooseUsSection: {
        title: "Perché sceglierci?",
        cards: [
            {
                title: "Convenienza",
                description: "Pianifica tutto il tuo viaggio da un'unica piattaforma, risparmiando tempo e fatica. Basta passare da un sito all'altro."
            },
            {
                title: "Garanzia del miglior prezzo",
                description: "Collaboriamo con partner di viaggio affidabili per offrirti le migliori offerte, sia che tu stia prenotando un volo, un hotel o un'auto a noleggio."
            },
            {
                title: "Supporto clienti",
                description: "Il nostro team di supporto dedicato è a tua disposizione 24 ore su 24, 7 giorni su 7, garantendo che i tuoi piani di viaggio si svolgano senza intoppi dall'inizio alla fine."
            },
            {
                title: "Esperienze di viaggio personalizzate",
                description: "Sia che tu stia viaggiando per affari, per una vacanza in famiglia o per un'avventura da solo, offriamo opzioni che soddisfano tutte le esigenze."
            }
        ]
    },

    contactUsSection: {
        breadcrumb: {
            home: "Inizio",
            pages: "Pagine",
            contactUs: "Contatto"
        },
        title: "Contatta il nostro team di supporto dedicato",
        description: "Il nostro team è pronto ad aiutarti. La tua soddisfazione è la nostra priorità.",
        info: [
            {
                label: "Indirizzo email",
                value: "portugaltourway@gmail.com"
            },
            {
                label: "Numero di telefono",
                value: "INSERIRE NUMERO"
            },
            {
                label: "La nostra posizione",
                value: "INSERIRE VIA, Almada - Portogallo"
            }
        ],
        supportCard: {
            title: "Hai bisogno di supporto?",
            textLoggedOut: "Per contattare il nostro team di supporto e aprire ticket, devi creare un account o effettuare il login. Dopodiché, avrai accesso completo alla tua dashboard di supporto, dove potrai seguire e gestire le tue richieste.",
            textLoggedIn: "Sei già loggato! Ora puoi aprire un nuovo ticket di supporto o seguire i ticket esistenti direttamente dalla tua dashboard.",
            btnLoggedOut: "Crea Account / Accedi",
            btnLoggedIn: "Apri Ticket nella Dashboard"
        }
    },

    sidebar: {
        main: "Principale",
        dashboard: "Pannello di controllo",
        myBookings: "Le mie prenotazioni",
        myReviews: "Le mie recensioni",
        wishlist: "Lista dei desideri",
        support: "Supporto",
        finance: "Finanza",
        wallet: "Portafoglio",
        payments: "Pagamenti",
        account: "Account",
        myProfile: "Il mio profilo",
        notifications: "Notifiche",
        settings: "Impostazioni",
        preferences: "Preferenze",
        logout: "Esci",
    },

    agentSidebar: {
        dashboard: "Pannello di controllo",
        bookings: "Prenotazioni",
        tukTukBookings: "Prenotazioni Tuk Tuk",
        hotelBookings: "Prenotazioni hotel",
        carBookings: "Prenotazioni auto",
        cruiseBookings: "Prenotazioni crociere",
        tourBookings: "Prenotazioni tour",
        flightBookings: "Prenotazioni voli",
        enquiries: "Richieste",
        earnings: "Guadagni",
        reviews: "Recensioni",
        support: "Supporto",
        serviceEnrollment: "Registrazione servizi",
        drivers: "Autisti",
        tukTukVehicles: "Veicoli Tuk Tuk",
        settings: "Impostazioni",
        logout: "Esci",
    },

    dashboardCards: {
        totalBookings: "Totale Pacchetti Acquistati",
        totalListings: "Totale Pacchetti",
        totalEarnings: "Guadagni Totali",
        totalReviews: "Recensioni Totali",
    },

    recentlyadded: {
        titulo: "Aggiunto di recente",
    },

    BookingsStatistics: {
        titulo: "Statistiche prenotazioni",
        loading: "Caricamento statistiche...",
        none: "Nessuna prenotazione ancora registrata.",
    }
};